import { Modal, ModalBody, ModalHeader, ModalFooter, Button, Body, useToast } from '@workramp/ui';
import CopyToClipboard from 'react-copy-to-clipboard';
import { I18n } from '~/common/explicit-exports';

type Props = { header: string; body: string; link: string; isOpen: boolean; onClose: () => void };

export const CMSCopyLinkModal = ({ header, body, link, isOpen, onClose }: Props) => {
  const { open: openToast } = useToast();

  const CANCEL_BUTTON = I18n.t('js.admin.cms.copy_link_modal.cancel_button');
  const COPY_BUTTON = I18n.t('js.admin.cms.copy_link_modal.copy_button');
  const CONFIRMATION_TOAST = I18n.t('js.admin.cms.copy_link_modal.confirmation_toast');

  const onCopyHandler = () => {
    openToast({ children: <span>{CONFIRMATION_TOAST}</span> });
    onClose();
  };

  return (
    <Modal data-testid="copy-link-modal" isOpen={isOpen} onClose={() => onClose()}>
      <ModalHeader title={header} />
      <ModalBody>
        <Body level="lg" color="#5C5F62">
          {body}
        </Body>
      </ModalBody>
      <ModalFooter
        actions={
          <>
            <Button data-testid="cancel-button" variant="text" color="secondary" size="lg" onPress={() => onClose()}>
              {CANCEL_BUTTON}
            </Button>
            <CopyToClipboard text={link} onCopy={onCopyHandler}>
              <Button data-testid="copy-button" size="lg">
                {COPY_BUTTON}
              </Button>
            </CopyToClipboard>
          </>
        }
      />
    </Modal>
  );
};
